export const REDUCER_NAME="communitySlice";

export interface iCommunityRespone {
    communityId: string;
    vendorId: string;
    product: string;
    communityType: string;
    communityUrl: string;
    resoureType: string; 
    status: number;
    created_at: string;
    updated_at: string; 
    resourceType: string;
    images:iCommunityImages[],
    data: string
    storyType?: string;
    storyUrl?: string;
  }

export interface iCommunityImages{
  title:string;
  description:string;
  image:string
}

export interface iCommunityDTO {
    product?: string;
    storyType?: string;
    storyUrl?: string;
    // resoureType?: string; 
    // resourceType?: string;
    Video?: File | string;
    data?: string
}


export interface iCommunityState {
    communityDetail: iCommunityRespone | null;
    communityList: iCommunityRespone[];
    isLoading: boolean;
    errorMessage: string | null;
    wholesalerCommunity: iCommunityRespone[];
    wholesalerCommunityById: iCommunityRespone[];
}